export default "__VITE_ASSET__B93_DxdX__"